import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { border, colors } from '../../constants/styleConstants';

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
    width: '100%',
    '&:hover div': {
      display: 'block',
    },
  },
  text: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block',
    whiteSpace: 'nowrap',
  },
  tooltip: {
    position: 'absolute',
    top: '-18px',
    backgroundColor: colors.yellowLight,
    fontSize: '10px',
    lineHeight: '12px',
    border: border.lightGrey,
    display: 'none',
  },
}));

const EllipsisText = ({ text, target }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <a className={classes.text} href={text} target={target}>
        {text}
      </a>
      <div className={classes.tooltip}>{text}</div>
    </div>
  );
};

EllipsisText.propTypes = {
  text: PropTypes.string.isRequired,
  target: PropTypes.oneOf(['_self', '_blank']),
};

EllipsisText.defaultProps = {
  target: '_blank',
};

export default EllipsisText;
